import type { FireAnalyticsEvent } from '../../types';

type PreloadQueryVarsDiffEventPayload = {
	match: boolean;
	mismatchCount: number;
	search: {
		match: boolean;
		mismatchCount: number;
		mismatchFields: string[];
	};
	rightPanel: {
		match: boolean;
		mismatchCount: number;
		mismatchFields: string[];
	};
};

export const onPreloadQueryVarsDiff = ({
	match,
	mismatchCount,
	search,
	rightPanel,
}: PreloadQueryVarsDiffEventPayload): FireAnalyticsEvent => ({
	eventType: 'track',
	action: 'preloadQueryVarsDiff',
	actionSubject: 'searchPage',
	attributes: {
		additionalAttributes: {
			experienceName: 'search-page',
			match,
			mismatchCount,
			search,
			rightPanel,
		},
	},
});
